// extracted by mini-css-extract-plugin
var _1 = "PostHistory-module__animateUploadProgressBarWidth--RR07k";
var _2 = "PostHistory-module__animatedBackground--LqRwB";
var _3 = "PostHistory-module__restrictionContainer--g4DMX";
var _4 = "PostHistory-module__restrictionNote--CUfsU";
var _5 = "PostHistory-module__sectionHeader--itq15";
var _6 = "PostHistory-module__sectionsContainer--kbXe6";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "restrictionContainer", _4 as "restrictionNote", _5 as "sectionHeader", _6 as "sectionsContainer" }
